import React from 'react';
import AntConfigProvider from 'antd-core/es/config-provider';
import { useLocale } from '../locale/useLocale.js';
import { useTheme } from './Theme.js';
import { createAntdTheme } from './utils.js';

const ConfigProvider = ({ children }) => {
    const theme = useTheme();
    const locale = useLocale();
    return (React.createElement(AntConfigProvider, { prefixCls: 'tend-ui', locale: locale, theme: createAntdTheme(theme) }, children));
};

export { ConfigProvider };
//# sourceMappingURL=ConfigProvider.js.map
